<sgt-loading-info
  *ngIf="isLoading"
  title="Carregando Cliente"
  text="Aguarde um momento enquanto estamos carregando o cliente"
>
</sgt-loading-info>

<form #form="ngForm" class="container-form with-nav-tabs" novalidate>
  <!--Options-->
  <div class="row container-form-options" *ngIf="!embedded">
    <div class="col-12">
      <button
        *ngIf="config?.canEdit"
        type="button"
        class="btn btn-success mr-2"
        (click)="saveClick()"
        id="btnSave"
      >
        <i class="fas fa-check" aria-hidden="true"></i> Salvar
      </button>
      <button type="button" class="btn btn-light mr-2" (click)="cancel()">
        <i class="fas fa-undo" aria-hidden="true"></i> Cancelar
      </button>

      <!-- Análise Financeira -->
      <ng-template [ngIf]="configAnaliseFinanceira?.canRealizar">
        <sgt-cliente-analise-financeira-btn-options
          [idCliente]="entityAnaliseFinanceira.id"
          [status]="entityAnaliseFinanceira.statusAnaliseFinanceira"
          (afterIniciar)="onAfterIniciarAnaliseFinanceira($event)"
          (afterCancelarIniciar)="
            onAfterCancelarIniciarAnaliseFinanceira($event)
          "
          (concluir)="concluirAnaliseFinanceira()"
          (afterCancelarConcluir)="
            onAfterCancelarConcluirAnaliseFinanceira($event)
          "
          (revisar)="revisarAnaliseFinanceira()"
        >
        </sgt-cliente-analise-financeira-btn-options>
      </ng-template>
    </div>
  </div>

  <!-- Pré-Insert -->
  <ng-template [ngIf]="isShowPreInsertForm">
    <div class="row container-form-content">
      <div class="col-12 container-navs">
        <ul class="nav nav-tabs">
          <li class="nav-item">
            <a
              class="nav-link active"
              data-target="#clienteFormTabPrincipalPreInsert"
              data-toggle="tab"
              >Principal</a
            >
          </li>
        </ul>
        <div class="tab-content">
          <div
            class="tab-pane tab-principal active"
            id="clienteFormTabPrincipalPreInsert"
          >
            <sgt-cliente-pre-insert-form
              [isShowOrigem]="isShowOrigem"
              (confirm)="onConfirmPreInsert($event)"
            >
            </sgt-cliente-pre-insert-form>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

  <!--Content-->
  <ng-template [ngIf]="!isShowPreInsertForm">
    <div class="row container-form-content" *ngIf="!isLoading && entity">
      <div class="col-12 container-navs">
        <ul class="nav nav-tabs">
          <li class="nav-item">
            <a
              class="nav-link active"
              data-target="#clienteFormTabPrincipal"
              data-toggle="tab"
              ><i class="far fa-id-card"></i> Principal
            </a>
          </li>
          <li
            class="nav-item"
            *ngIf="
              config?.isModoCentralCompraCadastro && config?.isCentralCompras
            "
          >
            <a
              class="nav-link"
              data-target="#clienteFormTabParticipantesCentralCompras"
              data-toggle="tab"
              ><i class="fas fa-users"></i> Participantes
            </a>
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              data-target="#clienteFormTabClassificacoes"
              data-toggle="tab"
              ><i class="fas fa-tags"></i> Segmentos
            </a>
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              data-target="#clienteFormTabEnderecos"
              data-toggle="tab"
              ><i class="fas fa-address-book"></i> Endereços e Contatos
            </a>
          </li>
          <li class="nav-item" *ngIf="config?.isPessoaFisicaOuJuridica">
            <a
              class="nav-link"
              data-target="#clienteFormTabComercial"
              data-toggle="tab"
              ><i class="fas fa-handshake"></i> Comercial
            </a>
          </li>
          <li class="nav-item" *ngIf="config?.isPessoaFisicaOuJuridica">
            <a
              class="nav-link"
              data-target="#clienteFormTabLogistica"
              data-toggle="tab"
              ><i class="fas fa-truck"></i> Logística
            </a>
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              data-target="#clienteFormTabFinanceiro"
              data-toggle="tab"
              *ngIf="
                configAnaliseFinanceira?.canVisualizarCliente ||
                config?.isPessoaFisicaOuJuridica
              "
              ><i class="fas fa-coins"></i> Financeiro
            </a>
          </li>
          <li class="nav-item" *ngIf="config?.isPessoaFisicaOuJuridica">
            <a
              class="nav-link"
              data-target="#clienteFormTabAnexos"
              data-toggle="tab"
              (click)="onTabAnexosClick()"
              ><i class="fas fa-paperclip"></i> Anexos
            </a>
          </li>
          <li
            class="nav-item"
            *ngIf="config?.isPessoaJuridica"
            title="Atividades Econômicas e Quadro de Sócios e Administradores"
          >
            <a
              class="nav-link"
              data-target="#clienteFormTabCNAEsQSA"
              data-toggle="tab"
              ><i class="fas fa-balance-scale"></i> CNAEs e QSA
            </a>
          </li>
          <li
            class="nav-item"
            *ngIf="
              config?.isPessoaFisicaOuJuridica &&
              entity.pessoa &&
              entity.pessoa.id
            "
          >
            <a
              class="nav-link"
              data-target="#clienteFormTabTitulos"
              data-toggle="tab"
              (click)="onTabTitulosClick()"
              ><i class="fas fa-file-invoice-dollar"></i> Títulos
            </a>
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              data-target="#clienteFormTabAtividades"
              data-toggle="tab"
              (click)="onTabAtividadeClick()"
              *ngIf="config?.isShowAtividades"
              ><i class="fas fa-clipboard-list"></i> Atividades
            </a>
          </li>
          <li
            class="nav-item"
            *ngIf="
              config?.isPessoaFisicaOuJuridica &&
              entity.pessoa &&
              entity.pessoa.id
            "
          >
            <a
              class="nav-link"
              data-target="#clienteFormTabCampanhas"
              data-toggle="tab"
              (click)="onTabCampanhasClick()"
              ><i class="fas fa-bullhorn"></i> Campanhas
            </a>
          </li>
          <li
            class="nav-item"
            *ngIf="
              config?.isPessoaFisicaOuJuridica &&
              entity.pessoa &&
              entity.pessoa.id
            "
          >
            <a
              class="nav-link"
              data-target="#clienteFormTabPedidos"
              data-toggle="tab"
              (click)="onTabPedidoClick()"
              ><i class="fas fa-shopping-cart"></i> Pedidos
            </a>
          </li>
          <li
            class="nav-item"
            *ngIf="
              config?.isPessoaFisicaOuJuridica &&
              entity.pessoa &&
              entity.pessoa.id
            "
          >
            <a
              class="nav-link"
              data-target="#clienteFormTabCurvaAbcVenda"
              data-toggle="tab"
              (click)="onTabCurvaAbcVendaClick()"
              ><i class="fas fa-chart-bar"></i> Curva ABC de Vendas
            </a>
          </li>
          <!-- <li class="nav-item" *ngIf="entity && entity.id">
                        <a class="nav-link" data-target="#clienteFormTabAtendimentos" data-toggle="tab">Atendimentos</a>
                    </li>                                                                                 -->
        </ul>

        <div class="tab-content">
          <!-- Principal -->
          <div
            class="tab-pane tab-principal active"
            id="clienteFormTabPrincipal"
          >
            <div class="row mb-3" *ngIf="entity.aiMetadata?.aiAssisted">
              <div class="col-12">
                <span class="badge badge-powered">
                  <img
                    src="assets/img/aya-agent-avatar.jpg"
                    alt="AyA"
                    class="badge-powered__avatar"
                  />
                  Criado por Aya
                </span>
              </div>
            </div>

            <div
              class="row"
              *ngIf="!isRepresentante && !entity.clientePrimario"
            >
              <div class="form-group col-12">
                <span class="badge badge-primary">Cliente Secundário</span>
                <p class="form-text text-muted">
                  Isto significa que este cliente foi cadastrado a partir de um
                  outro cadastro de cliente com o mesmo CNPJ/CPF.
                </p>
              </div>
            </div>

            <!-- Confirmar revisão pendente -->
            <sgt-cliente-revisao-confirmar
              #clienteRevisaoConfirmar
              [entity]="entity"
            >
            </sgt-cliente-revisao-confirmar>

            <!-- Origem -->
            <div class="row" *ngIf="isShowOrigem">
              <div class="form-group col-12 col-xl">
                <label for="origem" class="col-form-label">Origem</label>
                <sgt-origem-select
                  *ngIf="config.canEditOrigem"
                  #origemSelect
                  [idOrigem]="entity.origem"
                  (idOrigemChange)="onChangeOrigem($event)"
                  [required]="true"
                >
                </sgt-origem-select>

                <sgt-origem-input-group
                  *ngIf="!config.canEditOrigem"
                  [origem]="entity.origem"
                >
                </sgt-origem-input-group>

                <div class="form-text text-muted">
                  Origem deste {{ entity.cadastro | clienteCadastro }}
                </div>
              </div>

              <!-- Canal de Mídia Social de Origem -->
              <div
                class="form-group col-12 col-xl"
                *ngIf="isOrigemMidiaSocial()"
              >
                <label for="canalMidiaSocial" class="col-form-label"
                  >Canal da Mídia Social</label
                >
                <sgt-canal-midia-social-select
                  *ngIf="config.canEditOrigem"
                  #canalMidiaSocialSelect
                  [idCanalMidiaSocial]="entity.canalMidiaSocial"
                  (idCanalMidiaSocialChange)="entity.canalMidiaSocial = $event"
                  name="canalMidiaSocial"
                  id="canalMidiaSocial"
                  [required]="true"
                >
                </sgt-canal-midia-social-select>

                <sgt-canal-midia-social-input-group
                  *ngIf="!config.canEditOrigem"
                  [canalMidiaSocial]="entity.canalMidiaSocial"
                >
                </sgt-canal-midia-social-input-group>
                <div class="form-text text-muted">
                  Canal da mídia social que originou este
                  {{ config?.isProspect ? 'Prospect' : 'Cliente' }}
                </div>
              </div>

              <!-- Canal de Venda de Origem -->
              <div
                class="form-group col-12 col-xl"
                *ngIf="config?.isOrigemPossuiCanalVenda"
              >
                <label class="col-form-label">Canal de Venda de Origem</label>
                <sgt-canal-venda-select
                  *ngIf="config.canEditOrigem"
                  #canalVendaOrigemSelect
                  [(idCanalVenda)]="entity.idCanalVendaOrigem"
                  [(canalVenda)]="entity.canalVendaOrigem"
                  [required]="true"
                >
                </sgt-canal-venda-select>

                <sgt-canal-venda-input-group
                  *ngIf="!config.canEditOrigem"
                  [canalVenda]="entity.canalVendaOrigem"
                >
                </sgt-canal-venda-input-group>
                <p class="form-text text-muted">
                  Canal de venda que originou este
                  {{ config?.isProspect ? 'Prospect' : 'Cliente' }}
                </p>
              </div>
            </div>

            <!-- Campanha de Origem -->
            <div class="row" *ngIf="isOrigemCampanha()">
              <div class="form-group col-12">
                <label for="campanhaOrigem" class="col-form-label"
                  >Campanha de Origem</label
                >
                <sgt-campanha-select
                  #campanhaOrigemSelect
                  [(ngModel)]="entity.idCampanhaOrigem"
                  [campanha]="entity.campanhaOrigem"
                  (campanhaChange)="onChangeCampanhaOrigem($event)"
                  name="campanhaOrigem"
                  id="campanhaOrigem"
                  #campanhaOrigemModel="ngModel"
                  required="required"
                  [disabled]="!config.canEditOrigem"
                  [somenteEmAndamento]="true"
                  [objetivoAquisicao]="true"
                >
                </sgt-campanha-select>
                <div class="form-text text-muted">
                  Campanha que originou este
                  {{ config?.isProspect ? 'Prospect' : 'Cliente' }}
                </div>
                <sgt-form-control-error
                  *ngIf="
                    campanhaOrigemModel.errors &&
                    campanhaOrigemModel.errors.required &&
                    campanhaOrigemModel.dirty
                  "
                  msgError="A campanha de origem é obrigatória"
                >
                </sgt-form-control-error>
              </div>
            </div>

            <!-- Campanha de Aquisição -->
            <div class="row" *ngIf="entity.idCampanhaAquisicao">
              <div class="form-group col-12">
                <label class="col-form-label">Campanha de Aquisição</label>
                <sgt-campanha-select
                  [ngModel]="entity.idCampanhaAquisicao"
                  [campanha]="entity.campanhaAquisicao"
                  [disabled]="true"
                >
                </sgt-campanha-select>
                <div class="form-text text-muted">
                  Campanha que adquiriu este cliente
                </div>
              </div>
            </div>

            <!-- Pessoa -->
            <div class="row">
              <div class="col-12">
                <sgt-pessoa-form
                  [entity]="entity.pessoa"
                  [canEdit]="config?.canEditFichaCadastral"
                  [editMode]="editMode"
                  [dataCadastro]="entity.dataCadastro"
                  [tipoCadastro]="tipoCadastro"
                  [isNomeFantasiaRequired]="isNomeFantasiaRequired()"
                  [isDataFundacaoRequired]="config?.isDataFundacaoRequired"
                  [clienteCadastro]="entity.cadastro"
                  [clienteCadastroLabel]="entity.cadastro | clienteCadastro"
                  [clienteSituacao]="entity.situacao"
                  [clienteSituacaoLabel]="entity.situacao | clienteSituacao"
                  [clienteRevisaoPendente]="isRevisaoPendente()"
                  [clienteDataUltimaRevisao]="entity.dataUltimaRevisao"
                  [clienteUsuarioUltimaRevisao]="entity.usuarioUltimaRevisao"
                  [clienteDataCongelamento]="entity.dataCongelamento"
                  [clienteUsuarioCongelamento]="entity.usuarioCongelamento"
                  [clienteMotivoCongelamento]="entity.motivoCongelamento"
                  [clienteJustificativaCongelamento]="
                    entity.justificativaCongelamento
                  "
                  [clienteDataPreBaixa]="entity.dataPreBaixa"
                  [clientePreBaixaManual]="entity.preBaixaManual"
                  [clienteUsuarioPreBaixa]="entity.usuarioPreBaixa"
                  [clienteDataBaixa]="entity.dataBaixa"
                  [clienteBaixaManual]="entity.baixaManual"
                  [clienteUsuarioBaixa]="entity.usuarioBaixa"
                  [clienteMotivoBaixa]="entity.motivoBaixa"
                  [canEditTipo]="false"
                  [canEditCnpjCpf]="false"
                  [isConsultandoCnpj]="isConsultandoCnpj"
                  (validarCnpjCpfCadastrado)="onValidarCnpjCpfCadastrado()"
                  (tipoChange)="onChangeTipoPessoa($event)"
                  (exteriorChange)="onChangeExterior($event)"
                  #pessoaForm
                >
                </sgt-pessoa-form>
              </div>
            </div>
            <!-- End Pessoa -->
            <!-- <div class="row">
                            <div class="form-group col-xs col-md-3">
                                <label for="situacao" class="control-label">Situação</label>
                                <select class="form-control" name="situacao" id="situacao"
                                    [ngModel]="entity.situacao || ''" (ngModelChange)="entity.situacao = $event ? $event : null"
                                    #situacao="ngModel" required="required" [disabled]="!config?.canEditFichaCadastral && configCliente?.bloquearEdicaoSituacao">
                                    <option value="">Selecione a situação...</option>
                                    <option *ngFor="let situacao of situacoes" [ngValue]="situacao.id">{{situacao.nome}}</option>
                                </select>
                                <sgt-form-control-error
                                    *ngIf="situacao.errors && situacao.errors.required && situacao.dirty"
                                    msgError="A situação é obrigatória">
                                </sgt-form-control-error>
                            </div>
                        </div> -->

            <div class="row" *ngIf="!isRepresentante">
              <div class="form-group col-12 col-md-9 col-lg-10">
                <label for="representante" class="col-form-label"
                  >Representante</label
                >
                <sgt-typeahead-representante
                  [(ngModel)]="entity.representante"
                  name="representante"
                  id="representante"
                  #representante="ngModel"
                  [ngControl]="representante"
                  [situacao]="1"
                  (typeaheadChange)="onTypeaheadChangeRepresentante($event)"
                  (entitySelected)="onRepresentanteSelected()"
                  (clearEntity)="onClearRepresentante()"
                  [required]="isRepresentanteRequired()"
                  [disabled]="!config?.canEditFichaCadastral"
                  [readonly]="!config?.canEditFichaCadastral"
                >
                </sgt-typeahead-representante>
                <sgt-form-control-error
                  *ngIf="
                    representante.errors &&
                    representante.errors.required &&
                    representante.dirty
                  "
                  msgError="O representante é obrigatório"
                >
                </sgt-form-control-error>
              </div>
              <div class="form-group col-12 col-md-3 col-lg-2">
                <label for="percComissaoRepresentante" class="col-form-label"
                  >Comissão</label
                >
                <div class="input-group">
                  <sgt-decimal
                    [(ngModel)]="entity.percComissaoRepresentante"
                    name="percComissaoRepresentante"
                    id="percComissaoRepresentante"
                    #percComissaoRepresentante="ngModel"
                    [ngControl]="percComissaoRepresentante"
                    [disabled]="!config?.canEditFichaCadastral"
                    [readonly]="!config?.canEditFichaCadastral"
                  >
                  </sgt-decimal>
                  <div class="input-group-append">
                    <span class="input-group-text">%</span>
                  </div>
                </div>
                <sgt-form-control-error
                  *ngIf="
                    percComissaoRepresentante.errors &&
                    percComissaoRepresentante.errors.decimalInvalid
                  "
                  msgError="Comissão inválida"
                >
                </sgt-form-control-error>
              </div>
            </div>

            <div class="row" *ngIf="!isRepresentante">
              <div class="form-group col-12 col-md-6">
                <label for="usuarioGerente" class="col-form-label">Gerente</label>
                <sgt-typeahead-usuario
                  [(ngModel)]="entity.usuarioGerente"
                  name="usuarioGerente"
                  id="usuarioGerente"
                  #usuarioGerente="ngModel"
                  [ngControl]="usuarioGerente"
                  [perfil]="3"
                  [ativos]="true"
                  [escopo]="escopoVinculo"
                  (typeaheadChange)="onTypeaheadChangeUsuarioGerente($event)"
                  [disabled]="!config?.canEditFichaCadastral"
                  [readonly]="!config?.canEditFichaCadastral"
                >
                </sgt-typeahead-usuario>
              </div>
              <div class="form-group col-12 col-md-6">
                <label for="usuarioAtendente" class="col-form-label"
                  >Atendente</label
                >
                <sgt-typeahead-usuario
                  [(ngModel)]="entity.usuarioAtendente"
                  name="usuarioAtendente"
                  id="usuarioAtendente"
                  #usuarioAtendente="ngModel"
                  [ngControl]="usuarioAtendente"
                  [perfil]="4"
                  [ativos]="true"
                  [escopo]="escopoVinculo"
                  (typeaheadChange)="onTypeaheadChangeUsuarioAtendente($event)"
                  [disabled]="!config?.canEditFichaCadastral"
                  [readonly]="!config?.canEditFichaCadastral"
                >
                </sgt-typeahead-usuario>
              </div>
            </div>

            <div class="row">
              <div class="form-group col-12 col-md">
                <label for="periodicidadeCompra" class="col-form-label"
                  >Periodicidade de Compra</label
                >
                <sgt-periodicidade-compra-select
                  *ngIf="config?.canEdit"
                  [pendingSelectionId]="entity.idPeriodicidadeCompra"
                  [selectorSettings]="selectPeriodicidadeCompraSettings"
                  [isToShowTabelaVigenciaCarteiraCliente]="true"
                  [enableAutoSelectSingleOption]="true"
                  (changed)="onChangePeriodicidadeCompra($event)"
                >
                </sgt-periodicidade-compra-select>

                <input
                  *ngIf="!config?.canEdit"
                  type="text"
                  class="form-control"
                  [value]="entity.periodicidadeCompra?.nome"
                  disabled
                  readonly
                />
              </div>

              <div class="form-group col-12 col-md">
                <label for="periodicidadeCompraSemana" class="col-form-label"
                  >Periodicidade de Compra Semana</label
                >
                <sgt-semana-select
                  *ngIf="config?.canEdit"
                  [semana]="entity.periodicidadeCompraSemana"
                  (changed)="onChangeSemana($event)"
                ></sgt-semana-select>

                <input
                  *ngIf="!config?.canEdit"
                  type="text"
                  class="form-control"
                  [value]="
                    entity.periodicidadeCompraSemana | periodicidadeCompraSemana
                  "
                  disabled
                  readonly
                />
              </div>
            </div>

            <div class="row container-moeda">
              <div class="form-group col-xs col-md-3">
                <label for="moeda" class="control-label">Moeda</label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">{{
                      entity.moeda | moedaSimbolo
                    }}</span>
                  </div>
                  <select
                    class="form-control"
                    name="moeda"
                    id="moeda"
                    [ngModel]="entity.moeda || ''"
                    (ngModelChange)="entity.moeda = $event ? $event : null"
                    #moeda="ngModel"
                    [disabled]="!config?.canEditMoeda"
                    [required]="config?.canEditMoeda"
                  >
                    <option value="">Selecione a moeda...</option>
                    <option *ngFor="let moeda of moedas" [ngValue]="moeda.id">
                      {{ moeda.nome }}
                    </option>
                  </select>
                </div>
                <p class="form-text text-muted">Moeda utilizada pelo cliente</p>
                <sgt-form-control-error
                  *ngIf="moeda.errors && moeda.errors.required && moeda.dirty"
                  msgError="A moeda é obrigatória"
                >
                </sgt-form-control-error>
              </div>
            </div>

            <!-- Simples Nacional -->
            <div class="mb-3" *ngIf="config?.isPessoaJuridica">
              <sgt-simples-nacional-form
                #simplesNacionalForm
                [entity]="entity"
                [canEdit]="config?.canEditFichaCadastral"
              >
              </sgt-simples-nacional-form>
            </div>

            <!-- MEI -->
            <div
              class="mb-3"
              *ngIf="config?.isPessoaJuridica && entity.optanteSimplesNacional"
            >
              <sgt-mei-form
                #meiForm
                [entity]="entity"
                [canEdit]="config?.canEditFichaCadastral"
              >
              </sgt-mei-form>
            </div>

            <!-- IPI -->
            <div
              class="mb-3"
              *ngIf="config?.isPessoaJuridica && configEmpresa?.aplicaIpi"
            >
              <sgt-pessoa-ipi-form
                #ipiForm
                [entity]="entity"
                [canEdit]="config?.canEditFichaCadastral"
              >
              </sgt-pessoa-ipi-form>
            </div>

            <div class="row" *ngIf="entity.rotaEntregaErpSCR">
              <div class="form-group col-12">
                <label class="col-form-label">Rota de Entrega</label>
                <input
                  type="text"
                  class="form-control"
                  [value]="entity.rotaEntregaErpSCR"
                  disabled="disabled"
                  readonly="readonly"
                />
              </div>
            </div>

            <div class="row" *ngIf="entity.lead && entity.lead.anotacao">
              <div class="form-group col-12">
                <label class="col-form-label">Anotação do Lead</label>
                <textarea
                  class="form-control"
                  rows="1"
                  sgtAutosize
                  disabled="disabled"
                  readonly="readonly"
                  >{{ entity.lead.anotacao }}</textarea
                >
              </div>
            </div>
            <div class="row">
              <div class="form-group col-12">
                <label for="parecerRepresentante" class="col-form-label"
                  >Parecer do Representante</label
                >
                <textarea
                  class="form-control"
                  [(ngModel)]="entity.parecerRepresentante"
                  name="parecerRepresentante"
                  id="parecerRepresentante"
                  #parecerRepresentante="ngModel"
                  rows="5"
                  sgtUppercase
                  [disabled]="!config?.canEdit"
                  [readonly]="!config?.canEdit"
                >
                </textarea>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-12">
                <label for="anotacao" class="col-form-label">Anotação</label>
                <textarea
                  class="form-control"
                  [(ngModel)]="entity.anotacao"
                  name="anotacao"
                  id="anotacao"
                  #anotacao="ngModel"
                  rows="5"
                  sgtUppercase
                  [disabled]="!config?.canEditFichaCadastral"
                  [readonly]="!config?.canEditFichaCadastral"
                >
                </textarea>
              </div>
            </div>
          </div>
          <!-- End Principal -->

          <!-- Participantes Central de Compras -->
          <div
            class="tab-pane"
            id="clienteFormTabParticipantesCentralCompras"
            *ngIf="
              config?.isModoCentralCompraCadastro && config?.isCentralCompras
            "
          >
            <sgt-cliente-central-compra-participante-form
              #clienteCentralCompraParticipanteForm
              [canEdit]="config?.canEdit"
              [(entities)]="entity.participantesCentralCompra"
              [percParticipacaoTotalCentralCompra]="
                entity.percParticipacaoTotalCentralCompra
              "
            >
            </sgt-cliente-central-compra-participante-form>
          </div>

          <!-- Classificações -->
          <div class="tab-pane" id="clienteFormTabClassificacoes">
            <!-- Tipo Fiscal -->
            <div class="row" *ngIf="configCliente?.exibirTipoFiscal">
              <div class="form-group col-12 col-md">
                <label for="tipoFiscal" class="col-form-label"
                  >Tipo Fiscal</label
                >
                <ng-template [ngIf]="config?.canEditTipoFiscal">
                  <sgt-cliente-tipo-fiscal-select
                    [(ngModel)]="entity.tipoFiscal"
                    #tipoFiscal="ngModel"
                    name="tipoFiscal"
                    id="tipoFiscal"
                    required="required"
                    [canSelectNull]="false"
                  >
                  </sgt-cliente-tipo-fiscal-select>
                  <p class="form-text text-muted">
                    {{ entity.tipoFiscal | clienteTipoFiscalDescricao }}
                  </p>
                  <sgt-form-control-error
                    *ngIf="
                      tipoFiscal.errors &&
                      tipoFiscal.errors.required &&
                      tipoFiscal.dirty
                    "
                    msgError="O tipo fiscal do cliente é obrigatório"
                  >
                  </sgt-form-control-error>
                </ng-template>
                <ng-template [ngIf]="!config?.canEditTipoFiscal">
                  <input
                    type="text"
                    class="form-control"
                    [value]="entity.tipoFiscal | clienteTipoFiscal"
                    disabled="disabled"
                    readonly="readonly"
                  />
                </ng-template>
              </div>
            </div>

            <sgt-cliente-classificacao-form
              #clienteClassificacaoForm
              [canEdit]="config?.canEditClienteSegmentos"
              [idCliente]="entity.id"
              [(entities)]="entity.classificacoes"
            >
            </sgt-cliente-classificacao-form>

            <!-- Central de Compras -->
            <ng-template [ngIf]="entity.idClienteCentralCompra">
              <div class="row">
                <div class="form-group col-12">
                  <sgt-cliente-central-compra-form-control-text
                    [id]="entity.clienteCentralCompra?.id"
                    [nome]="entity.clienteCentralCompra?.pessoa?.nome"
                    [nomeFantasia]="
                      entity.clienteCentralCompra?.pessoa?.nomeFantasia
                    "
                    helpText="Central de compras onde este {{
                      config?.isProspect ? 'prospect' : 'cliente'
                    }} é um participante"
                    (openCentralCompra)="openCentralCompras($event)"
                  >
                  </sgt-cliente-central-compra-form-control-text>
                </div>
              </div>
            </ng-template>

            <div class="row">
              <div class="form-group col-12 col-md">
                <p class="mb-0"><strong>Tags:</strong></p>
                <sgt-seletor-tags
                  [selectedTags]="tags"
                  [settings]="seletorTagsSettings"
                  (tagsChange)="onTagsChange($event)"
                >
                </sgt-seletor-tags>
              </div>
            </div>

            <div class="row">
              <div class="form-group col-12 col-md">
                <sgt-portfolio-categoria-tree-table
                  [selectedPortfolios]="portfolios"
                  [disabled]="!config?.canEdit"
                  (portfoliosChange)="onPortfolioChange($event)"
                >
                </sgt-portfolio-categoria-tree-table>
              </div>
            </div>

            <div class="row">
              <div class="form-group col-12 col-md">
                <label for="regiao" class="col-form-label">Região</label>
                <sgt-regiao-select
                  #regiaoSelect
                  [(ngModel)]="entity.idRegiao"
                  [regiao]="entity.regiao"
                  #regiao="ngModel"
                  name="regiao"
                  id="regiao"
                  [disabled]="!config?.canEdit"
                  [required]="configCliente?.obrigarRegiao"
                  [somenteAtivas]="true"
                  [idRepresentanteFilter]="entity.idRepresentante"
                >
                </sgt-regiao-select>
                <sgt-form-control-error
                  *ngIf="
                    regiao.errors && regiao.errors.required && regiao.dirty
                  "
                  msgError="A região é obrigatória"
                >
                </sgt-form-control-error>
              </div>
            </div>

            <!-- Grupos e Vínculos -->
            <div class="mb-3" *ngIf="config?.isPessoaFisicaOuJuridica">
              <sgt-accordion [settings]="{ isCollapsed: true }">
                <h6 header class="m-0">Grupos e Vínculos</h6>

                <div class="row">
                  <div class="form-group col-12">
                    <label for="grupoEconomico" class="col-form-label"
                      >Grupo Econômico</label
                    >
                    <select
                      class="form-control"
                      name="grupoEconomico"
                      id="grupoEconomico"
                      [ngModel]="entity.idClienteGrupoEconomico || ''"
                      (ngModelChange)="
                        onChangeGrupoEconomico($event ? $event : null)
                      "
                      #grupo="ngModel"
                      [disabled]="!config?.canEdit"
                    >
                      <option value="">Nenhum grupo econômico</option>
                      <option
                        *ngFor="let grupoEconomico of gruposEconomicos"
                        [ngValue]="grupoEconomico.id"
                      >
                        {{ grupoEconomico.nome }}
                      </option>
                    </select>
                    <p style="margin-bottom: 0px" class="form-text text-muted">
                      Grupo econômico que este cliente pertence
                    </p>
                  </div>
                </div>
                <div class="row" *ngIf="configCliente?.exibirMatriz">
                  <div class="form-group col-12">
                    <label for="pessoaMatriz" class="col-form-label"
                      >Matriz</label
                    >
                    <sgt-typeahead-cliente-pessoa
                      [(ngModel)]="entity.pessoaMatriz"
                      name="pessoaMatriz"
                      id="pessoaMatriz"
                      #pessoaMatriz="ngModel"
                      [ngControl]="pessoaMatriz"
                      [exibirRevisaoPendente]="true"
                      [cadastroProspect]="true"
                      [cadastroCliente]="true"
                      (typeaheadChange)="onTypeaheadChangeClienteMatriz($event)"
                      [disabled]="!config?.canEdit"
                      [readonly]="!config?.canEdit"
                    >
                    </sgt-typeahead-cliente-pessoa>
                    <p style="margin-bottom: 0px" class="form-text text-muted">
                      Selecione a matriz deste cliente para vincular os
                      cadastrados
                    </p>
                  </div>
                </div>
                <div class="row" *ngIf="config?.isModoCentralCompraReferencia">
                  <div class="col-12">
                    <sgt-cliente-central-compra-v1
                      [idCliente]="entity.id"
                      [isCadastroCliente]="true"
                      [(entity)]="entity.clienteCentralCompra"
                      (entityChange)="onChangeClienteCentralCompra($event)"
                    >
                    </sgt-cliente-central-compra-v1>
                  </div>
                </div>
              </sgt-accordion>
            </div>

            <div class="mb-3">
              <sgt-accordion [settings]="{ isCollapsed: true }">
                <h6 header class="m-0">Classificações</h6>

                <div class="row">
                  <div class="form-group col-12 col-md">
                    <label
                      for="classificacaoFaturamentoPretendida"
                      class="col-form-label"
                      >Classificação {{ KPI_RAP.sigla }}</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      [value]="entity.classificacaoFaturamentoPretendida?.nome"
                      name="classificacaoFaturamentoPretendida"
                      id="classificacaoFaturamentoPretendida"
                      disabled="disabled"
                      readonly="readonly"
                    />
                    <p class="form-text text-muted">
                      Classificação {{ KPI_RAP.nome }}
                    </p>
                  </div>
                  <div class="form-group col-12 customer-share-form-group">
                    <label class="col-form-label"
                      >{{ KPI_CUSTOMER_SHARE.nome }} {{ KPI_RAP.sigla }}</label
                    >
                    <div class="input-group">
                      <input
                        type="text"
                        class="form-control text-right"
                        value="{{
                          entity.customerSharePretendido
                            | decimalFormat: 1 : 0 : 0
                        }}{{
                          entity.customerSharePretendido != null &&
                          entity.customerSharePretendido !== undefined
                            ? '%'
                            : ''
                        }}"
                        disabled="disabled"
                        readonly="readonly"
                      />
                      <div
                        class="input-group-append"
                        *ngIf="entity.indicadorCustomerSharePretendido"
                      >
                        <span class="input-group-text">
                          <sgt-customer-share-indicador-badge
                            [indicador]="
                              entity.indicadorCustomerSharePretendido
                            "
                          >
                          </sgt-customer-share-indicador-badge>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-12 col-md">
                    <label for="classificacaoFaturamento" class="col-form-label"
                      >Classificação {{ KPI_RAR.sigla }}</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      [value]="entity.classificacaoFaturamentoRealizada?.nome"
                      name="classificacaoFaturamento"
                      id="classificacaoFaturamento"
                      disabled="disabled"
                      readonly="readonly"
                    />
                    <p class="form-text text-muted">
                      Classificação {{ KPI_RAR.nome }}
                    </p>
                  </div>
                  <div class="form-group col-12 customer-share-form-group">
                    <label class="col-form-label"
                      >{{ KPI_CUSTOMER_SHARE.nome }} {{ KPI_RAR.sigla }}</label
                    >
                    <div class="input-group">
                      <input
                        type="text"
                        class="form-control text-right"
                        value="{{
                          entity.customerShareRealizado
                            | decimalFormat: 1 : 0 : 0
                        }}{{
                          entity.customerShareRealizado != null &&
                          entity.customerShareRealizado !== undefined
                            ? '%'
                            : ''
                        }}"
                        disabled="disabled"
                        readonly="readonly"
                      />
                      <div
                        class="input-group-append"
                        *ngIf="entity.indicadorCustomerShareRealizado"
                      >
                        <span class="input-group-text">
                          <sgt-customer-share-indicador-badge
                            [indicador]="entity.indicadorCustomerShareRealizado"
                          >
                          </sgt-customer-share-indicador-badge>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </sgt-accordion>
            </div>
          </div>

          <!-- Endereços -->
          <div class="tab-pane endereco" id="clienteFormTabEnderecos">
            <!-- Principal -->
            <div class="mb-3">
              <sgt-pessoa-endereco-unico
                #pessoaEnderecoPrincipal
                enderecoCollapseGroupTitle="Endereço Principal"
                [canEdit]="config?.canEditFichaCadastral"
                [tipoPessoa]="entity.pessoa.tipo"
                [tipoEndereco]="enderecoPrincipal"
                [(entity)]="entity.pessoa.enderecoPrincipal"
                [idRepresentante]="entity.idRepresentante"
                [tipoCadastro]="tipoCadastro"
                [clienteCadastro]="entity.cadastro"
                [permiteExcluir]="false"
                [cepRequired]="isCepRequired()"
                [logradouroRequired]="isLogradouroRequired()"
                [numeroRequired]="isNumeroRequired()"
                [bairroRequired]="isBairroRequired()"
                [inscricaoEstadualRequired]="isInscricaoEstadualRequired()"
                [exibirInscricaoSuframa]="configCliente?.exibirInscricaoSuframa"
                [exibirInscricaoProdutorRural]="
                  configCliente?.exibirInscricaoProdutorRural
                "
                [exterior]="entity.pessoa.exterior"
                contatoCollapseGroupTitle="Contato Principal"
                [telefoneRequired]="isTelefoneRequired()"
                [celularRequired]="configCliente?.obrigarCelular"
                [emailRequired]="configCliente?.obrigarEmail"
                [tipoContato]="contatoPrincipal"
                [(entityContato)]="entity.pessoa.contatoPrincipal"
              >
              </sgt-pessoa-endereco-unico>
            </div>

            <!-- Outros Contatos -->
            <hr />
            <div class="mb-3" *ngIf="config?.isPessoaFisicaOuJuridica">
              <sgt-pessoa-contato
                [canEdit]="config?.canEdit"
                title="Outros Contatos"
                idTable="tablePessoaContatosClienteForm"
                [idPessoa]="entity.pessoa.id"
                [entities]="entity.pessoa.outrosContatos"
                #pessoaOutrosContatosCadastro
                [showTableTitle]="false"
              >
              </sgt-pessoa-contato>
            </div>

            <!-- Cobrança -->
            <hr />
            <div *ngIf="config?.isPessoaFisicaOuJuridica">
              <sgt-pessoa-endereco-unico
                #pessoaEnderecoCobranca
                enderecoCollapseGroupTitle="Endereço de Cobrança"
                [canEdit]="config?.canEditFichaCadastral"
                [tipoPessoa]="entity.pessoa.tipo"
                [tipoEndereco]="enderecoCobranca"
                [(entity)]="entity.pessoa.enderecoCobranca"
                [idRepresentante]="entity.idRepresentante"
                [tipoCadastro]="tipoCadastro"
                [clienteCadastro]="entity.cadastro"
                [permiteExcluir]="config?.canEditFichaCadastral"
                [telefoneRequired]="false"
                [cepRequired]="!entity.pessoa.exterior"
                [bairroRequired]="!entity.pessoa.exterior"
                [cepRequired]="isCepRequired()"
                [inscricaoEstadualRequired]="isInscricaoEstadualRequired()"
                [exibirInscricaoSuframa]="configCliente?.exibirInscricaoSuframa"
                [exibirInscricaoProdutorRural]="
                  configCliente?.exibirInscricaoProdutorRural
                "
                [exterior]="entity.pessoa.exterior"
                contatoCollapseGroupTitle="Contato de Cobrança"
                [tipoContato]="contatoCobranca"
                [(entityContato)]="entity.pessoa.contatoCobranca"
              >
              </sgt-pessoa-endereco-unico>
            </div>

            <!-- Entrega -->
            <hr />
            <div *ngIf="config?.isPessoaFisicaOuJuridica">
              <sgt-pessoa-endereco-unico
                #pessoaEnderecoEntrega
                enderecoCollapseGroupTitle="Endereço de Entrega"
                [canEdit]="config?.canEditFichaCadastral"
                [tipoPessoa]="entity.pessoa.tipo"
                [tipoEndereco]="enderecoEntrega"
                [(entity)]="entity.pessoa.enderecoEntrega"
                [idRepresentante]="entity.idRepresentante"
                [tipoCadastro]="tipoCadastro"
                [clienteCadastro]="entity.cadastro"
                [permiteExcluir]="config?.canEditFichaCadastral"
                [telefoneRequired]="false"
                [cepRequired]="!entity.pessoa.exterior"
                [bairroRequired]="!entity.pessoa.exterior"
                [cepRequired]="isCepRequired()"
                [inscricaoEstadualRequired]="isInscricaoEstadualRequired()"
                [exibirInscricaoSuframa]="configCliente?.exibirInscricaoSuframa"
                [exibirInscricaoProdutorRural]="
                  configCliente?.exibirInscricaoProdutorRural
                "
                [exterior]="entity.pessoa.exterior"
                contatoCollapseGroupTitle="Contato de Entrega"
                [tipoContato]="contatoEntrega"
                [(entityContato)]="entity.pessoa.contatoEntrega"
              >
              </sgt-pessoa-endereco-unico>
            </div>
          </div>
          <!-- End Endereços -->

          <!-- Comercial -->
          <div
            class="tab-pane tab-comercial"
            id="clienteFormTabComercial"
            *ngIf="config?.isPessoaFisicaOuJuridica"
          >
            <!-- Condições Comerciais -->
            <div class="mb-3">
              <sgt-accordion [settings]="{ isCollapsed: true }">
                <h6 header class="m-0">Condições Comerciais</h6>

                <div class="row">
                  <div class="form-group col-12">
                    <div class="custom-control custom-switch">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        [(ngModel)]="entity.possuiValidadePropostaComercial"
                        name="possuiValidadePropostaComercial"
                        id="possuiValidadePropostaComercial"
                        [disabled]="!config?.canEdit"
                      />
                    </div>
                    <p class="form-text text-muted">
                      Indica se o cliente possui validade nas propostas
                      comerciais. Quando selecionado, os orçamentos e pedidos
                      deste cliente precisarão possuir uma data de validade.
                    </p>
                  </div>
                </div>

                <div class="row" *ngIf="configCliente?.exibirExigeOcComXML">
                  <div class="form-group col-12">
                    <div class="custom-control custom-switch">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        [(ngModel)]="entity.exigeOrdemCompraComXml"
                        name="exigeOrdemCompraComXml"
                        id="exigeOrdemCompraComXml"
                        [disabled]="!config?.canEdit"
                        [readonly]="!config?.canEdit"
                      />
                      <label
                        class="custom-control-label"
                        for="exigeOrdemCompraComXml"
                        >Exige Ordem de Compra?</label
                      >
                    </div>
                    <p class="form-text text-muted">
                      Marque esta opção se o cliente exige que o número da Ordem
                      de Compra seja informado nos pedidos e na nota fiscal.
                    </p>
                  </div>
                </div>

                <div class="row">
                  <div class="form-group col-12">
                    <label for="tabelaPreco" class="col-form-label"
                      >Tabela de Preço</label
                    >
                    <sgt-tabela-preco-select
                      #tabelaPrecoSelect
                      [(ngModel)]="entity.idTabelaPreco"
                      [(tabelaPreco)]="entity.tabelaPreco"
                      name="tabelaPreco"
                      id="tabelaPreco"
                      #tabelaPreco="ngModel"
                      [disabled]="!config?.canEdit"
                      [somenteAtivas]="true"
                      [somenteTabelasPrecosRepresentante]="true"
                    >
                    </sgt-tabela-preco-select>
                    <div class="form-text text-muted">
                      Tabela de preço padrão do cliente
                    </div>
                  </div>
                </div>
              </sgt-accordion>
            </div>

            <!-- Internet -->
            <hr class="mt-0" />
            <div class="mb-3">
              <sgt-cliente-internet-form
                #clienteInternetForm
                [canEdit]="config?.canEdit"
                [entity]="entity"
                [(site)]="entity.pessoa.site"
              >
              </sgt-cliente-internet-form>
            </div>

            <!-- Contrato -->
            <hr class="mt-0" />
            <div class="mb-3">
              <sgt-cliente-contrato-form
                #contratoForm
                [entity]="entity"
                [canEdit]="config?.canEdit"
                [editMode]="editMode"
              >
              </sgt-cliente-contrato-form>
            </div>

            <!-- Mercado e Concorrência -->
            <hr class="mt-0" />
            <div class="mb-3">
              <sgt-accordion
                [settings]="{ isCollapsed: true, expanded: false }"
              >
                <h6 header class="m-0">Mercado e Concorrência</h6>

                <!-- Unidades de Negócios -->
                <sgt-cliente-unidade-negocio2
                  *ngIf="isTipoMercadoUnidadeNegocio()"
                  [canEdit]="config?.canEdit"
                  [idCliente]="entity.id"
                  #clienteUnidadeNegocio
                >
                </sgt-cliente-unidade-negocio2>

                <div class="row">
                  <div class="form-group col-12 col-md-3">
                    <label for="posicaoMarca" class="col-form-label"
                      >Posição da Empresa</label
                    >
                    <input
                      type="number"
                      class="form-control"
                      [(ngModel)]="entity.posicaoMarca"
                      name="posicaoMarca"
                      id="posicaoMarca"
                      #posicaoMarca="ngModel"
                      [disabled]="!config?.canEdit"
                      [readonly]="!config?.canEdit"
                    />
                  </div>
                </div>

                <!-- Concorrentes -->
                <sgt-cliente-concorrente
                  [canEdit]="config?.canEdit"
                  [entities]="entity.concorrentes"
                  #clienteConcorrenteForm
                >
                </sgt-cliente-concorrente>
              </sgt-accordion>
            </div>

            <!-- Fornecedores -->
            <hr class="mt-0" />
            <div class="mb-3">
              <sgt-accordion
                [settings]="{ isCollapsed: true, expanded: false }"
              >
                <h6 header class="m-0">Fornecedor 1</h6>
                <div class="row">
                  <div class="form-group col-12 col-md-9">
                    <label for="nomeFornecedor1" class="col-form-label"
                      >Nome</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      [(ngModel)]="entity.nomeFornecedor1"
                      name="nomeFornecedor1"
                      id="nomeFornecedor1"
                      #nomeFornecedor1="ngModel"
                      maxlength="255"
                      sgtUppercase
                      [disabled]="!config?.canEdit"
                      [readonly]="!config?.canEdit"
                    />
                    <sgt-form-control-error
                      *ngIf="
                        nomeFornecedor1.errors &&
                        nomeFornecedor1.errors.maxlength
                      "
                      msgError="O nome do fornecedor deve ter no máximo 255 caracteres"
                    >
                    </sgt-form-control-error>
                  </div>
                  <div class="form-group col-12 col-md-3">
                    <label for="foneFornecedor1" class="col-form-label"
                      >Telefone</label
                    >
                    <input
                      type="tel"
                      class="form-control"
                      [(ngModel)]="entity.foneFornecedor1"
                      name="foneFornecedor1"
                      id="foneFornecedor1"
                      #foneFornecedor1="ngModel"
                      sgtFone
                      [disabled]="!config?.canEdit"
                      [readonly]="!config?.canEdit"
                    />
                    <sgt-form-control-error
                      *ngIf="
                        foneFornecedor1.errors &&
                        foneFornecedor1.errors.foneInvalido
                      "
                      msgError="O telefone deve ter no míninio 10 dígitos com o DDD"
                    >
                    </sgt-form-control-error>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-12">
                    <label for="retornoFornecedor1" class="col-form-label"
                      >Retorno</label
                    >
                    <textarea
                      *ngIf="canEditRetornoFornecedor()"
                      class="form-control"
                      [(ngModel)]="entity.retornoFornecedor1"
                      name="retornoFornecedor1"
                      id="retornoFornecedor1"
                      #retornoFornecedor1="ngModel"
                      rows="3"
                      sgtUppercase
                    >
                    </textarea>
                    <textarea
                      *ngIf="!canEditRetornoFornecedor()"
                      class="form-control"
                      name="retornoFornecedor1"
                      id="retornoFornecedor1"
                      rows="3"
                      disabled="disabled"
                      readonly="readonly"
                      >{{ entity.retornoFornecedor1 }}</textarea
                    >
                    <p class="form-text text-muted">
                      Anotações e comentários sobre o retorno deste fornecedor
                    </p>
                  </div>
                </div>
              </sgt-accordion>
            </div>

            <div class="mb-3">
              <sgt-accordion
                [settings]="{ isCollapsed: true, expanded: false }"
              >
                <h6 header class="m-0">Fornecedor 2</h6>
                <div class="row">
                  <div class="form-group col-12 col-md-9">
                    <label for="nomeFornecedor2" class="col-form-label"
                      >Nome</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      [(ngModel)]="entity.nomeFornecedor2"
                      name="nomeFornecedor2"
                      id="nomeFornecedor2"
                      #nomeFornecedor2="ngModel"
                      maxlength="255"
                      sgtUppercase
                      [disabled]="!config?.canEdit"
                      [readonly]="!config?.canEdit"
                    />
                    <sgt-form-control-error
                      *ngIf="
                        nomeFornecedor2.errors &&
                        nomeFornecedor2.errors.maxlength
                      "
                      msgError="O nome do fornecedor deve ter no máximo 255 caracteres"
                    >
                    </sgt-form-control-error>
                  </div>
                  <div class="form-group col-12 col-md-3">
                    <label for="foneFornecedor2" class="col-form-label"
                      >Telefone</label
                    >
                    <input
                      type="tel"
                      class="form-control"
                      [(ngModel)]="entity.foneFornecedor2"
                      name="foneFornecedor2"
                      id="foneFornecedor2"
                      #foneFornecedor2="ngModel"
                      sgtFone
                      [disabled]="!config?.canEdit"
                      [readonly]="!config?.canEdit"
                    />
                    <sgt-form-control-error
                      *ngIf="
                        foneFornecedor2.errors &&
                        foneFornecedor2.errors.foneInvalido
                      "
                      msgError="O telefone deve ter no míninio 10 dígitos com o DDD"
                    >
                    </sgt-form-control-error>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-12">
                    <label for="retornoFornecedor2" class="col-form-label"
                      >Retorno</label
                    >
                    <textarea
                      *ngIf="canEditRetornoFornecedor()"
                      class="form-control"
                      [(ngModel)]="entity.retornoFornecedor2"
                      name="retornoFornecedor2"
                      id="retornoFornecedor2"
                      #retornoFornecedor2="ngModel"
                      rows="3"
                      sgtUppercase
                    >
                    </textarea>
                    <textarea
                      *ngIf="!canEditRetornoFornecedor()"
                      class="form-control"
                      name="retornoFornecedor2"
                      id="retornoFornecedor2"
                      rows="3"
                      disabled="disabled"
                      readonly="readonly"
                      >{{ entity.retornoFornecedor2 }}</textarea
                    >
                    <p class="form-text text-muted">
                      Anotações e comentários sobre o retorno deste fornecedor
                    </p>
                  </div>
                </div>
              </sgt-accordion>
            </div>

            <div class="mb-3">
              <sgt-accordion
                [settings]="{ isCollapsed: true, expanded: false }"
              >
                <h6 header class="m-0">Fornecedor 3</h6>
                <div class="row">
                  <div class="form-group col-12 col-md-9">
                    <label for="nomeFornecedor3" class="col-form-label"
                      >Nome</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      [(ngModel)]="entity.nomeFornecedor3"
                      name="nomeFornecedor3"
                      id="nomeFornecedor3"
                      #nomeFornecedor3="ngModel"
                      maxlength="255"
                      sgtUppercase
                      [disabled]="!config?.canEdit"
                      [readonly]="!config?.canEdit"
                    />
                    <sgt-form-control-error
                      *ngIf="
                        nomeFornecedor3.errors &&
                        nomeFornecedor3.errors.maxlength
                      "
                      msgError="O nome do fornecedor deve ter no máximo 255 caracteres"
                    >
                    </sgt-form-control-error>
                  </div>
                  <div class="form-group col-12 col-md-3">
                    <label for="foneFornecedor3" class="col-form-label"
                      >Telefone</label
                    >
                    <input
                      type="tel"
                      class="form-control"
                      [(ngModel)]="entity.foneFornecedor3"
                      name="foneFornecedor3"
                      id="foneFornecedor3"
                      #foneFornecedor3="ngModel"
                      sgtFone
                      [disabled]="!config?.canEdit"
                      [readonly]="!config?.canEdit"
                    />
                    <sgt-form-control-error
                      *ngIf="
                        foneFornecedor3.errors &&
                        foneFornecedor3.errors.foneInvalido
                      "
                      msgError="O telefone deve ter no míninio 10 dígitos com o DDD"
                    >
                    </sgt-form-control-error>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-12">
                    <label for="retornoFornecedor3" class="col-form-label"
                      >Retorno</label
                    >
                    <textarea
                      *ngIf="canEditRetornoFornecedor()"
                      class="form-control"
                      [(ngModel)]="entity.retornoFornecedor3"
                      name="retornoFornecedor3"
                      id="retornoFornecedor3"
                      #retornoFornecedor3="ngModel"
                      rows="3"
                      sgtUppercase
                    >
                    </textarea>
                    <textarea
                      *ngIf="!canEditRetornoFornecedor()"
                      class="form-control"
                      name="retornoFornecedor3"
                      id="retornoFornecedor3"
                      rows="3"
                      disabled="disabled"
                      readonly="readonly"
                      >{{ entity.retornoFornecedor3 }}</textarea
                    >
                    <p class="form-text text-muted">
                      Anotações e comentários sobre o retorno deste fornecedor
                    </p>
                  </div>
                </div>
              </sgt-accordion>
            </div>

            <div class="mb-3">
              <sgt-accordion
                [settings]="{ isCollapsed: true, expanded: false }"
              >
                <h6 header class="m-0">Fornecedor 4</h6>
                <div class="row">
                  <div class="form-group col-12 col-md-9">
                    <label for="nomeFornecedor4" class="col-form-label"
                      >Nome</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      [(ngModel)]="entity.nomeFornecedor4"
                      name="nomeFornecedor4"
                      id="nomeFornecedor4"
                      #nomeFornecedor4="ngModel"
                      maxlength="255"
                      sgtUppercase
                      [disabled]="!config?.canEdit"
                      [readonly]="!config?.canEdit"
                    />
                    <sgt-form-control-error
                      *ngIf="
                        nomeFornecedor4.errors &&
                        nomeFornecedor4.errors.maxlength
                      "
                      msgError="O nome do fornecedor deve ter no máximo 255 caracteres"
                    >
                    </sgt-form-control-error>
                  </div>
                  <div class="form-group col-12 col-md-3">
                    <label for="foneFornecedor4" class="col-form-label"
                      >Telefone</label
                    >
                    <input
                      type="tel"
                      class="form-control"
                      [(ngModel)]="entity.foneFornecedor4"
                      name="foneFornecedor4"
                      id="foneFornecedor4"
                      #foneFornecedor4="ngModel"
                      sgtFone
                      [disabled]="!config?.canEdit"
                      [readonly]="!config?.canEdit"
                    />
                    <sgt-form-control-error
                      *ngIf="
                        foneFornecedor4.errors &&
                        foneFornecedor4.errors.foneInvalido
                      "
                      msgError="O telefone deve ter no míninio 10 dígitos com o DDD"
                    >
                    </sgt-form-control-error>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-12">
                    <label for="retornoFornecedor4" class="col-form-label"
                      >Retorno</label
                    >
                    <textarea
                      *ngIf="canEditRetornoFornecedor()"
                      class="form-control"
                      [(ngModel)]="entity.retornoFornecedor4"
                      name="retornoFornecedor4"
                      id="retornoFornecedor4"
                      #retornoFornecedor4="ngModel"
                      rows="3"
                      sgtUppercase
                    >
                    </textarea>
                    <textarea
                      *ngIf="!canEditRetornoFornecedor()"
                      class="form-control"
                      name="retornoFornecedor4"
                      id="retornoFornecedor4"
                      rows="3"
                      disabled="disabled"
                      readonly="readonly"
                      >{{ entity.retornoFornecedor4 }}</textarea
                    >
                    <p class="form-text text-muted">
                      Anotações e comentários sobre o retorno deste fornecedor
                    </p>
                  </div>
                </div>
              </sgt-accordion>
            </div>

            <div class="mb-3">
              <sgt-accordion
                [settings]="{ isCollapsed: true, expanded: false }"
              >
                <h6 header class="m-0">Fornecedor 5</h6>
                <div class="row">
                  <div class="form-group col-12 col-md-9">
                    <label for="nomeFornecedor5" class="col-form-label"
                      >Nome</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      [(ngModel)]="entity.nomeFornecedor5"
                      name="nomeFornecedor5"
                      id="nomeFornecedor5"
                      #nomeFornecedor5="ngModel"
                      maxlength="255"
                      sgtUppercase
                      [disabled]="!config?.canEdit"
                      [readonly]="!config?.canEdit"
                    />
                    <sgt-form-control-error
                      *ngIf="
                        nomeFornecedor5.errors &&
                        nomeFornecedor5.errors.maxlength
                      "
                      msgError="O nome do fornecedor deve ter no máximo 255 caracteres"
                    >
                    </sgt-form-control-error>
                  </div>
                  <div class="form-group col-12 col-md-3">
                    <label for="foneFornecedor5" class="col-form-label"
                      >Telefone</label
                    >
                    <input
                      type="tel"
                      class="form-control"
                      [(ngModel)]="entity.foneFornecedor5"
                      name="foneFornecedor5"
                      id="foneFornecedor5"
                      #foneFornecedor5="ngModel"
                      sgtFone
                      [disabled]="!config?.canEdit"
                      [readonly]="!config?.canEdit"
                    />
                    <sgt-form-control-error
                      *ngIf="
                        foneFornecedor5.errors &&
                        foneFornecedor5.errors.foneInvalido
                      "
                      msgError="O telefone deve ter no míninio 10 dígitos com o DDD"
                    >
                    </sgt-form-control-error>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-12">
                    <label for="retornoFornecedor5" class="col-form-label"
                      >Retorno</label
                    >
                    <textarea
                      *ngIf="canEditRetornoFornecedor()"
                      class="form-control"
                      [(ngModel)]="entity.retornoFornecedor5"
                      name="retornoFornecedor5"
                      id="retornoFornecedor5"
                      #retornoFornecedor5="ngModel"
                      rows="3"
                      sgtUppercase
                    >
                    </textarea>
                    <textarea
                      *ngIf="!canEditRetornoFornecedor()"
                      class="form-control"
                      name="retornoFornecedor5"
                      id="retornoFornecedor5"
                      rows="3"
                      disabled="disabled"
                      readonly="readonly"
                      >{{ entity.retornoFornecedor5 }}</textarea
                    >
                    <p class="form-text text-muted">
                      Anotações e comentários sobre o retorno deste fornecedor
                    </p>
                  </div>
                </div>
              </sgt-accordion>
            </div>
          </div>
          <!-- End Comercial -->

          <!-- Logística -->
          <div
            class="tab-pane"
            id="clienteFormTabLogistica"
            *ngIf="config?.isPessoaFisicaOuJuridica"
          >
            <sgt-cliente-logistica-form
              #logisticaForm
              [entity]="entity"
              [canEdit]="config?.canEdit"
            >
            </sgt-cliente-logistica-form>
          </div>
          <!-- End Logística -->

          <!-- Tab Anexos-->
          <div
            class="tab-pane tab-pane-anexos"
            id="clienteFormTabAnexos"
            *ngIf="config?.isPessoaFisicaOuJuridica"
          >
            <ng-template [ngIf]="configEmpresa?.possuiTermoLGPD">
              <div class="mb-3">
                <sgt-accordion [settings]="{ isCollapsed: true }">
                  <h6 header class="m-0">Termo LGPD</h6>
                  <sgt-pessoa-termo-lgpd-form
                    #termoLGPDForm
                    [canEdit]="config?.canEdit"
                    [idPessoa]="entity.pessoa.id"
                    [delegateImprimir]="true"
                    (onImprimir)="onImprimirTermoLGPD()"
                    (afterImprimir)="afterImprimirTermoLGPD()"
                  >
                  </sgt-pessoa-termo-lgpd-form>
                </sgt-accordion>
              </div>

              <hr class="mt-0" />
            </ng-template>

            <sgt-cliente-arquivo
              #clienteArquivos
              [idCliente]="entity.id"
              [canEdit]="config?.canEdit"
              [editMode]="editMode"
              [(arquivosUpload)]="entity.arquivosUpload"
              [mensagemInformativa]="configCliente?.mensagemInformativaAnexos"
            >
            </sgt-cliente-arquivo>
          </div>
          <!-- End Tab Anexos-->

          <!-- CNAEs -->
          <div
            class="tab-pane"
            id="clienteFormTabCNAEsQSA"
            *ngIf="config?.isPessoaJuridica"
          >
            <div class="row">
              <div class="form-group col-12">
                <sgt-cnaes-view
                  [cnaePrincipal]="entity.pessoa.cnaePrincipal"
                  [cnaesSecundarias]="
                    entity.pessoa.cnaesSecundarias | cnaeSecundariasViewerMap
                  "
                >
                </sgt-cnaes-view>
              </div>
            </div>

            <!-- Capital Social e Sócios -->
            <div class="row">
              <div class="form-group col-12 col-md-4">
                <sgt-capital-social-form-control-text
                  [capitalSocial]="entity.pessoa.capitalSocial"
                >
                </sgt-capital-social-form-control-text>
              </div>
            </div>

            <div class="row">
              <div class="form-group col-12">
                <sgt-socio-view [socios]="entity.pessoa.socios">
                </sgt-socio-view>
              </div>
            </div>
          </div>

          <!-- Financeiro -->
          <div
            class="tab-pane tab-financeiro"
            id="clienteFormTabFinanceiro"
            *ngIf="
              configAnaliseFinanceira?.canVisualizarCliente ||
              config?.isPessoaFisicaOuJuridica
            "
          >
            <!-- Análise Financeira  -->
            <sgt-cliente-analise-financeira
              *ngIf="configAnaliseFinanceira?.canVisualizarCliente"
              [idCliente]="entity.id"
              [cliente]="entityAnaliseFinanceira"
              (clienteChange)="onChangeAnaliseFinanceira($event)"
              [showCliente]="false"
              [showRepresentante]="false"
            >
            </sgt-cliente-analise-financeira>

            <sgt-cliente-financeiro-form
              *ngIf="config?.isPessoaFisicaOuJuridica"
              #financeiroForm
              [entity]="entity"
              [canEdit]="config?.canEdit"
            >
            </sgt-cliente-financeiro-form>
          </div>
          <!-- End Financeiro -->

          <!-- Títulos -->
          <div
            class="tab-pane tab-titulos"
            id="clienteFormTabTitulos"
            *ngIf="
              config?.isPessoaFisicaOuJuridica &&
              entity.pessoa &&
              entity.pessoa.id
            "
          >
            <ng-template [ngIf]="config?.isShowContentTabTitulos">
              <sgt-cliente-titulo
                #clienteTitulo
                [idsPessoasFilter]="[entity.pessoa.id]"
                [idRepresentante]="entity.idRepresentante"
                [isShowLimiteCredito]="false"
              >
              </sgt-cliente-titulo>
            </ng-template>
          </div>
          <!-- End Títulos -->

          <!-- Tab Atividades-->
          <div
            class="tab-pane tab-pane-atividades"
            id="clienteFormTabAtividades"
            *ngIf="config?.isShowAtividades"
          >
            <sgt-cliente-atividade #clienteAtividade [idCliente]="entity.id">
            </sgt-cliente-atividade>
          </div>
          <!-- End Tab Atividades-->

          <!-- Campanhas -->
          <div
            class="tab-pane campanhas"
            id="clienteFormTabCampanhas"
            *ngIf="
              config?.isPessoaFisicaOuJuridica &&
              entity.pessoa &&
              entity.pessoa.id
            "
          >
            <sgt-campanha-view-embedded
              #clienteCampanhas
              [filterStorageKey]="clienteCampanhaFilter"
              [filterPeriodicidadeVigenciaDefault]="
                clienteCampanhaPeriodicidadeAnualFilter
              "
              [visualizacaoStorageKey]="clienteCampanhaVisualizacao"
              [visualizacaoModoDefault]="
                clienteCampanhaModoDashboardVisualizacao
              "
              [isShowFilterRepresentantes]="false"
              [isShowFilterCliente]="false"
              [idPessoaFilter]="entity.pessoa.id"
            >
            </sgt-campanha-view-embedded>
          </div>
          <!-- End Campanhas -->

          <!-- Pedidos -->
          <div
            class="tab-pane pedidos"
            id="clienteFormTabPedidos"
            *ngIf="
              config?.isPessoaFisicaOuJuridica &&
              entity.pessoa &&
              entity.pessoa.id
            "
          >
            <sgt-cliente-pedido
              #clientePedido
              [entity]="entity"
              [pessoa]="entity.pessoa"
              [idRepresentante]="entity.idRepresentante"
            >
            </sgt-cliente-pedido>
          </div>
          <!-- End Pedidos -->

          <!-- Curva ABC Venda -->
          <div
            class="tab-pane tab-curva-abc-venda"
            id="clienteFormTabCurvaAbcVenda"
            *ngIf="
              config?.isPessoaFisicaOuJuridica &&
              entity.pessoa &&
              entity.pessoa.id
            "
          >
            <sgt-curva-abc-venda
              #clienteCurvaAbcVenda
              filterStorageKey="curvaAbcVendaFilterCliente"
              [idPessoaFilter]="entity.pessoa?.id"
            >
            </sgt-curva-abc-venda>
          </div>
          <!-- End Curva ABC Venda -->

          <!-- Atendimentos -->
          <!-- <div class="tab-pane tab-atendimentos" id="clienteFormTabAtendimentos" *ngIf="entity && entity.id">
                        <sgt-cliente-atendimento
                            [entity]="entity">
                        </sgt-cliente-atendimento>
                    </div> -->
          <!-- End Atendimentos -->
        </div>
      </div>
    </div>
  </ng-template>
</form>

<!-- Modal para concluir a Análise Financeira do Cliente -->
<sgt-cliente-analise-financeira-concluir-modal
  #analiseFinanceiraConcluirModal
  (afterConcluir)="onAfterConcluirAnaliseFinanceira($event)"
>
</sgt-cliente-analise-financeira-concluir-modal>

<!-- Modal para revisar a Análise Financeira do Cliente -->
<sgt-cliente-analise-financeira-revisar-modal
  #analiseFinanceiraRevisarModal
  (afterRevisar)="onAfterRevisarAnaliseFinanceira($event)"
>
</sgt-cliente-analise-financeira-revisar-modal>
